import CORE_ROUTES, { NOT_FOUND_ROUTE } from './core.routes';

const ApplicationRoutes = {
  Routes: [...CORE_ROUTES, NOT_FOUND_ROUTE]
};

export default ApplicationRoutes;
